function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: 755,
    height: 607,
    viewBox: "0 0 755.0000000000006 606.999999999999",
    enableBackground: "new 0 0 578 462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 225.3801993123471,585.25 -26.7694797455667,-35.25 -43.8896525235758,-50.3230445277813 -50.2210670432046,-40.0882581530303 -56.74999999999993,-35.9962453546368 -24.75000000000004,-12.9970072272631 15.50000000000006,-74.5954447372885 15.5,-77.1647346197068 1.50999789340672,-2.8352653802932 20.24999999999995,9.4236293220665 18.74000210659325,9.4236293220665 29.11074879661699,29.3263706779335 29.1107487966171,29.3263706779335 13.214567068002,21.25 13.9345384565016,21.25 97.4572144055204,-102 121.1721824767419,-114.4814784644757 89,-69.95668711536742 114.973409270599,-79.36892397440396 57.0706610685825,71.30708955424688 64.6108902742039,81.83779648198262 8.8135726182045,12 -62.25,36.092656967498 -62.2185332315898,34.9304534494805 -65.5,45.9578639313265 -164.2334506486918,127.8561582488706 -44.7334506486919,40.3250709208418 -37.601038908247,42.5 -52.7665493513082,63.2255371869551 -16.1749636542898,20.75 z",
    style: {
      fill: "#21b04b"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.8f1f3b03788840ae999712d8028a0fff.svg";
export { ForwardRef as ReactComponent };